import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

const iconProps = { width: 42, height: 42, xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' };

const CAMPAIGN_FEATURES = [
  {
    title: 'Estética audiovisual (en estudio)',
    icon: (
      <svg {...iconProps}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    body: (
      <>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          Todo ocurre en el ecosistema de TNO Network, con la iluminación de{' '}
          <strong>Expedientes del Delito</strong> (sombras marcadas, tonos azules y rojos, atmósfera de seriedad).
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>El visual:</strong> Santiago Gutiérrez y Angélica Lugo frente a cámara, con Danimar integrado en el set
          como pieza de evidencia clave.
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block">
          <strong>El tono:</strong> periodismo de investigación puro. Sin risas: solo eficacia y resolución profesional en estudio.
        </Typography>
      </>
    ),
  },
  {
    title: 'Frases de autoridad (historias)',
    icon: (
      <svg {...iconProps}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5l7 4v6l-7 4V5zM4 10v4a2 2 0 002 2h1l2 4h2l-2-4h2" />
      </svg>
    ),
    body: (
      <>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>3 historias semanales</strong> con las frases de Angélica Lugo (firmeza y veredicto) y Santiago Gutiérrez
          (cadencia y expediente).
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 2 }}>
          Queda para siempre en el programa: historias y piezas integradas a la biblioteca permanente del show en TNO
          Network.
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 2 }}>
          Referencia de copy (cadencia de Santiago y firmeza de Angélica):
        </Typography>
        <Typography variant="subtitle2" fontWeight={700} color="primary" display="block" gutterBottom>
          Angélica Lugo
        </Typography>
        <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1 }}>
          Firmeza y veredicto
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 2.5 }}>
          <Typography component="li" variant="body2" color="textSecondary" sx={{ mb: 1, fontStyle: 'italic' }}>
            En la limpieza, como en la justicia, no puede quedar rastro. Danimar: Caso cerrado.
          </Typography>
          <Typography component="li" variant="body2" color="textSecondary" sx={{ mb: 1, fontStyle: 'italic' }}>
            Cero evidencia de suciedad. Ese es nuestro veredicto.
          </Typography>
          <Typography component="li" variant="body2" color="textSecondary" sx={{ mb: 1, fontStyle: 'italic' }}>
            Danimar: Justicia para tus superficies.
          </Typography>
        </Box>
        <Typography variant="subtitle2" fontWeight={700} color="primary" display="block" gutterBottom>
          Santiago Gutiérrez
        </Typography>
        <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1 }}>
          Cadencia y expediente
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
          <Typography component="li" variant="body2" color="textSecondary" sx={{ mb: 1, fontStyle: 'italic' }}>
            Danimar: El especialista en escenas difíciles.
          </Typography>
          <Typography component="li" variant="body2" color="textSecondary" sx={{ mb: 1, fontStyle: 'italic' }}>
            Donde otros ven un desastre, nosotros vemos un expediente por resolver. Danimar: Limpieza de alto impacto.
          </Typography>
        </Box>
      </>
    ),
  },
  {
    title: 'Micro «Expediente Danimar» (autoridad dual)',
    icon: (
      <svg {...iconProps}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11l3 3a2 2 0 002.828 0L17 11m-9 5l-3 3m12-3l3 3M3 9l4-4a2 2 0 012.828 0L12 7l2.172-2.172a2 2 0 012.828 0L21 9" />
      </svg>
    ),
    body: (
      <>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>Apertura (Angélica):</strong> &quot;La suciedad persistente es un delito contra el orden de tu hogar.
          No aceptamos menos que la perfección.&quot;
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>Desarrollo (Santiago):</strong> &quot;Hemos analizado la fórmula de Danimar. No hay mancha que escape
          a su potencia. Es la solución técnica que estábamos esperando.&quot;
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>Cierre (dúo):</strong> &quot;Danimar. Porque tu hogar merece justicia.&quot;
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          <strong>Presencia en el set:</strong> una vez por emisión del programa, con producto integrado según el guion de
          campaña (al programa como tal, no repartida por bloques).
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1 }}>
          <strong>Presencia digital:</strong> logo de Danimar de forma permanente en el mini-site del programa{' '}
          (Expedientes del Delito) en TNO Network.
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block">
          <strong>Inserts en el programa:</strong>{' '}
          piezas audiovisuales de marca integradas en la emisión de Expedientes del Delito.
        </Typography>
      </>
    ),
  },
  {
    title: 'TNO Digest y SEO: el informe técnico',
    icon: (
      <svg {...iconProps}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    body: (
      <>
        <Typography variant="body2" color="textSecondary" component="span" display="block" sx={{ mb: 1.5 }}>
          Los textos de <strong>TNO Digest</strong> los elabora <strong>Angélica Lugo</strong>: el contenido deja de ser una
          reseña común para convertirse en un <strong>informe de peritaje</strong>, con datos sobre rendimiento y
          efectividad del producto.
        </Typography>
        <Typography variant="subtitle2" fontWeight={700} color="primary" display="block" gutterBottom>
          Titular SEO sugerido
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', mb: 1.5 }} component="span" display="block">
          &quot;Danimar: El informe técnico de Angélica Lugo sobre la eliminación total de residuos&quot;
        </Typography>
        <Typography variant="body2" color="textSecondary" component="span" display="block">
          Optimizado para que Google reconozca a la marca como autoridad en limpieza en Venezuela.
        </Typography>
      </>
    ),
  },
];

const CampaignContent = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color="secondary"
          align="center"
        >
          Campaña
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          align="center"
          gutterBottom
          data-aos="fade-up"
        >
          Justicia Implacable contra la Suciedad
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          data-aos="fade-up"
          sx={{ maxWidth: 720, mx: 'auto' }}
        >
          Concepto &quot;Caso Cerrado&quot;: campaña de intriga en estudio, con voces de autoridad y contenido editorial
          que trata a Danimar como solución técnica.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {CAMPAIGN_FEATURES.map((item, i) => (
          <Grid key={i} item xs={12} md={6}>
            <ListItem
              component="div"
              disableGutters
              sx={{
                alignItems: 'flex-start',
                padding: 0,
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <ListItemAvatar>
                <Box color={theme.palette.primary.main}>{item.icon}</Box>
              </ListItemAvatar>
              <ListItemText
                primary={item.title}
                secondary={item.body}
                primaryTypographyProps={{
                  variant: 'h6',
                  gutterBottom: true,
                  sx: { fontWeight: 700 },
                }}
                secondaryTypographyProps={{
                  component: 'div',
                }}
                sx={{
                  margin: 0,
                }}
              />
            </ListItem>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CampaignContent;
